import { NgModule, AfterContentInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

declare let $: any;

@Directive({
    selector: '[collapsable-wrapper]',
    standalone: false
})
export class CollapsableWrapperDirective implements AfterContentInit, OnDestroy {
    listenClick: Function;

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    ngAfterContentInit(): void {
        const $wrapper = $(this.el.nativeElement);

        const value = $wrapper.data('col');
        $wrapper.addClass(`col-${value}`);
        setTimeout(() => {
            const button = $wrapper.find('.btn-collapse');
            const buttonEl = (button.length) ? button[0] : "";
            if(!buttonEl) return;

            this.listenClick = this.renderer.listen(buttonEl, 'click', this.onClick);
        });
    }

    ngOnDestroy() {
        if(this.listenClick instanceof Function) {
            this.listenClick();
        }
    }

    onClick({target}) {
        const $wrapper = $(target).closest('*[collapsable-wrapper]');
        const $sidebar = $wrapper.children('mat-sidenav-container');
        const opened = $sidebar.attr('opened') === 'true';

        const value = $wrapper.data('col');
        const col_class = `col-${value}`;

        $sidebar.attr('opened', !opened);
        if(!opened) {
            const dir = $('body').attr('dir');
            const margin_side = dir === "ltr" ? 'marginLeft' : 'marginRight';
            $wrapper.toggleClass(col_class);
            $wrapper.find('.mat-sidenav-content').css(margin_side, '100%');
        } else {
            setTimeout(() => {
                $wrapper.toggleClass(col_class);
            }, 200);
        }
    }

}

@NgModule({
    declarations: [CollapsableWrapperDirective],
    exports: [CollapsableWrapperDirective]
})
export class CollapsableWrapperDirectiveModule {}
